import { render } from "./SettingVisualisation.vue?vue&type=template&id=b28578ae&scoped=true"
import script from "./SettingVisualisation.vue?vue&type=script&lang=js"
export * from "./SettingVisualisation.vue?vue&type=script&lang=js"

import "./SettingVisualisation.vue?vue&type=style&index=0&id=b28578ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b28578ae"

export default script